"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styles_1 = require("@material-ui/core/styles");
var useStatusClass_1 = __importDefault(require("./useStatusClass"));
var types_1 = require("../../types");
var useStyles = styles_1.makeStyles({
    root: {
        height: '100%',
        width: '100%',
    },
    input: {
        height: '80%',
        margin: '10%',
        padding: 0,
        width: '80%',
    },
});
var DocumentPageRadioInput = function (_a) {
    var onChange = _a.onChange, onFocus = _a.onFocus, input = _a.input;
    var id = input.id, status = input.status, value = input.value;
    var classes = useStyles();
    var statusClass = useStatusClass_1.default(status);
    return (react_1.default.createElement("div", { className: statusClass + " " + classes.root },
        react_1.default.createElement("input", { className: classes.input, "data-tid": "DocumentPageRadioInput-input-" + id, onChange: function () { return onChange(true); }, onFocus: function () { return onFocus(); }, checked: value !== null && value !== void 0 ? value : false, disabled: status === types_1.PageInputStatus.Disabled, type: "radio" })));
};
exports.default = DocumentPageRadioInput;
//# sourceMappingURL=DocumentPageRadioInput.js.map